import React, { Component } from "react";
import Header from "../../../Components/MainLayout/Header";
import store from "store";
import Axios from "axios";
import { connect } from "react-redux";
import Skeleton from "react-loading-skeleton";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});
class FeePayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collectfee: [],
      userData: this.props.user.user,
      student_info: this.props.user.student_info,
      student: this.props.user.student,
      student_class: this.props.user.student_class,
      student_section: this.props.user.student_section,
      session: this.props.user.session,
      selectcollectfee: [],
      total_amount: 0,
      razorpay_id: "",
      receipt_no: "Online_" + Math.floor(Math.random() * 100000),
      formData: {
        checkedcollectfee: [],
      },
      order: {},
      payment_date: `${new Date().getFullYear()}-${
        (new Date().getMonth() + 1 < 10 ? "0" : "") +
        (new Date().getMonth() + 1)
      }-${(new Date().getDate() < 10 ? "0" : "") + new Date().getDate()}`,
      paymentLink: null,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Fee Payment";
    this.fetchfee({
      school: this.state.userData.school.id,
      student: this.state.userData.id,
      session: this.props?.user?.student_info?.session?.id,
    });
  }

  fetchRazor = (params = {}) => {
    Axios.get("/api/onlinepayment", { params: { ...params } }).then((res) => {
      this.setState({ razorpay_id: res.data[0].razorpay_key_id });
    });
  };

  fetchfee = (params = {}) => {
    this.setState({ loading: true });
    Axios.get(`/api/collectfee`, {
      params: { ...params },
    })
      .then((res) => {
        this.setState({ collectfee: res.data, loading: false });
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };

  handleChange = (event) => {
    this.setState({ loading: true });
    const { formData } = this.state;
    formData[event.target.name] = event.target.value;
    this.setState({ formData });
  };

  handleCheckbox = (event) => {
    const { formData } = this.state;
    var selectcollectfee = this.state.selectcollectfee;
    var total_amount = this.state.total_amount;
    const index = selectcollectfee.indexOf(Number(event.target.value));
    let check = 0;
    for (let j = 0; j < this.state.selectcollectfee.length; j++) {
      if (
        Number(this.state.selectcollectfee[j]) === Number(event.target.value)
      ) {
        selectcollectfee.splice(index, 1);
        check = 1;
        for (let k = 0; k < this.state.collectfee.length; k++) {
          if (
            Number(this.state.collectfee[k].id) === Number(event.target.value)
          ) {
            total_amount =
              Number(total_amount) - this.state.collectfee[k].total_fee;
          }
        }
      }
    }

    if (check !== 1) {
      selectcollectfee.push(Number(event.target.value));
      for (let j = 0; j < this.state.collectfee.length; j++) {
        if (
          Number(this.state.collectfee[j].id) === Number(event.target.value)
        ) {
          total_amount =
            Number(total_amount) + Number(this.state.collectfee[j].total_fee);
        }
      }
    }

    formData["checkedcollectfee"] = selectcollectfee;
    this.setState({
      formData,
      selectcollectfee: selectcollectfee,
      total_amount: Number(total_amount),
      loading: false,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    // const data_form = {
    //   amount: JSON.stringify(this.state.total_amount * 100),
    //   currency: "INR",
    //   receipt: this.state.receipt_no.toString(),
    //   payment_capture: "1",
    //   notes: {
    //     address: this.state.userData.school.school_address,
    //     name: `${this.state.userData.first_name} ${this.state.userData.last_name}`,
    //     student_class: this.state.student_class.class_name,
    //     section: this.state.student_section.section_name,
    //   },
    // };

    // if (data_form) {
    // Razorpay Integration
    // Axios.post(`/api/payment`, data_form)
    //   .then((response) => {
    //     if (response.status === 200) {
    //       this.setState({ order: response.data, loading: false });
    //     }
    //   })
    //   .catch((error) => {
    //     this.setState({ loading: false });
    //   });

    let obj = {};
    obj.orderAmount = this.state.total_amount;
    obj.student_info = this.state.student_info.id;
    obj.fee_collected_details = "";
    obj.collect_fee = this.state.selectcollectfee;

    Axios.post(
      store.get("school_info").school_online_payment_config__payment_mode ===
        "cashfree"
        ? `/payment/cashfree-online-payment`
        : "/api/hdfc-payment",
      obj
    )
      .then((response) => {
        if (response.status === 200) {
          console.log(response.data, "resposne");

          if (response.data.type === "html") {
            var myWindow = window.open("", "response", "resizable=yes");
            myWindow.document.write(response.data.data);
            this.setState({
              loading: false,
            });
          } else {
            this.setState({
              paymentLink: response.data.payment_link,
              loading: false,
            });
          }
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };

  handlePayment = (e) => {
    e.preventDefault();
    var form_data = {
      student: this.state.userData.id,
      student_info: this.state.student_info.id,
      user: this.state.userData.id,
      amount_paid: Number(this.state.order.amount) / 100,
      amount_total: Number(this.state.order.amount) / 100,
      amount_left:
        Number(this.state.total_amount) - Number(this.state.order.amount) / 100,
      amount_discount: 0,
      school: this.state.userData.school.id,
      debit_detail: "Online Payment",
      payment_date: this.state.payment_date,
      student_class: this.state.student_class.id,
      section: this.state.student_section.id,
      session: this.state.session.id,
      collect_fee: this.state.selectcollectfee,
      payment_method: 4,
      transaction_no: Math.random() * 1000000000000000000,
    };
    var redirectlink = this.props.history.push;
    var options = {
      key: this.state.razorpay_id,
      amount: JSON.stringify(this.state.total_amount * 100),
      currency: "INR",
      name: this.state.userData.school.school_name,
      description: `${this.state.userData.username} Fee `,
      image: this.state.userData.school.logo,
      order_id: this.state.order.id,
      handler: function (response) {
        form_data["razorpay_payment_id"] = response.razorpay_payment_id;
        form_data["razorpay_order_id"] = response.razorpay_order_id;
        form_data["razorpay_signature"] = response.razorpay_signature;
        Axios.post(`/api/onlinefeepayment`, form_data).then((response1) => {
          if (response1.status === 201) {
            redirectlink(`/thankyou`);
          } else {
            redirectlink(`/failure`);
          }
        });
      },
      prefill: {
        name: `${this.state.userData.first_name} ${this.state.userData.last_name}`,
        email: this.state.userData.email,
        contact: this.state.userData.sms_number,
      },
      notes: {
        address: this.state.userData.school.school_address,
        name: `${this.state.userData.first_name} ${this.state.userData.last_name}`,
        student_class: this.state.student_class.class_name,
        section: this.state.student_section.section_name,
      },
      theme: {
        color: "#F37254",
      },
    };
    var rzp1 = new window.Razorpay(options);
    rzp1.open();
  };

  success = () => {
    alert("Successively Submitted");
  };

  error = (errorMessage) => {
    alert(errorMessage);
  };
  render() {
    console.log(this.state, "statatt");

    const FeeDueData = this.state.collectfee?.map((item) =>
      item.paid_status !== true ? (
        <div className="input-group in-line align-items-center pb-3">
          <input
            type="checkbox"
            onChange={this.handleCheckbox}
            name="checkecollectfee"
            color="primary"
            value={item.id}
            disabled={item?.paid_fee === 0 ? false : true}
            checked={
              this.state.selectcollectfee.includes(item.id) ? true : false
            }
          />
          <div className="th-12 th-cap pl-2">
            {`${
              item.fee_group
                ? item.fee_group.term_fee.term_name
                : "Back Due Of Last Session"
            }-${"RS"} ${item.total_fee - item.paid_fee}`}{" "}
            {this.state.order.id ? `disabled` : ""}
            {item?.paid_fee === 0 ? "" : "Partially Paid/Paid"}
          </div>
        </div>
      ) : (
        ""
      )
    );
    return (
      <div>
        <Header to="/payments" title="Fee Payment" />
        {this.state.loading ? (
          // <LoaderFull />
          <div className="container pt-3 col-12">
            <div className="shadow-sm rounded mb-2 p-3">
              <Skeleton width={100} />
              <Skeleton count={3} />
            </div>
          </div>
        ) : (
          <div className="container pt-3 col-12">
            <div className="shadow-sm rounded mb-2 p-3">
              {this.state.paymentLink ? (
                // {this.state.order.id ? (
                // <div>
                //   <div className="th-14 th-medium th-black pb-2">
                //     TOTAL:{" "}
                //     <span className="th-roboto">
                //       ₹ {this.state.total_amount}
                //     </span>
                //   </div>
                //   <button
                //     onClick={this.handlePayment}
                //     type="submit"
                //     className="w-100 th-btn-primary px-5 py-2"
                //   >
                //     PAY NOW
                //   </button>
                // </div>
                <div>
                  <div className="th-14 th-medium th-black pb-2">
                    Sub Total:{" "}
                    <span className="th-roboto">
                      ₹ {this.state.total_amount}
                    </span>
                  </div>
                  <div className="th-black pb-2">
                    <span className=" th-14  th-medium"> Convenience fee</span>{" "}
                    <span className="th-12">(2.2%)</span>:{" "}
                    <span className="th-roboto th-14">
                      ₹{" "}
                      {Math.round((this.state.total_amount * 0.022).toFixed(2))}
                    </span>
                  </div>
                  <div className="th-14 th-medium th-black pb-2">
                    Total:{" "}
                    <span className="th-roboto">
                      ₹{" "}
                      {this.state.total_amount +
                        Math.round(
                          (this.state.total_amount * 0.022).toFixed(2)
                        )}{" "}
                    </span>
                  </div>
                  <a href={this.state.paymentLink}>
                    {" "}
                    <button
                      type="submit"
                      className="w-100 th-btn-primary px-5 py-2"
                    >
                      PAY NOW
                    </button>
                  </a>
                </div>
              ) : (
                <form onSubmit={this.handleSubmit} autoComplete="off">
                  {FeeDueData}
                  <div className="th-14 th-medium th-black pb-2">
                    TOTAL:{" "}
                    <span className="th-roboto">
                      ₹ {this.state.total_amount}
                    </span>
                  </div>
                  {this.state.order.id ? (
                    ""
                  ) : (
                    <button
                      type="submit"
                      className="w-100 th-btn-primary px-5 py-2"
                    >
                      SUBMIT
                    </button>
                  )}
                </form>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}
export default connect(mapStateToProps)(FeePayment);
